import { motion } from "framer-motion";
import { GraduationCap, Award, MonitorCog } from "lucide-react";
import { SectionLabel, Reveal } from "./Section";
import { EDUCATION } from "../data/content";

const CAT_ICON = { degree: GraduationCap, course: Award, technical: MonitorCog };

export const Education = ({ t }) => {
  return (
    <section id="education" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel num={t.education.num} label={t.education.label} id="education" />

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <Reveal>
            <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl">{t.education.title}</h2>
          </Reveal>
          <p className="text-[#8b95a5] max-w-sm md:text-right">{t.education.sub}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {EDUCATION.map((e, i) => {
            const Icon = CAT_ICON[e.cat] || Award;
            return (
              <motion.div
                key={e.title + e.year}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.06, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`education-card-${i}`}
                className="group relative bg-[#0c0e14] border border-[#1a1d27] rounded-xl p-6 flex flex-col justify-between overflow-hidden hover:border-[#2563eb] transition-colors duration-300 min-h-[190px]"
              >
                <div className="absolute -right-10 -top-10 w-28 h-28 rounded-full bg-[#2563eb]/0 group-hover:bg-[#2563eb]/15 blur-2xl transition-colors duration-500" />

                <div className="flex items-start justify-between">
                  <span className="flex items-center justify-center w-10 h-10 rounded-lg border border-[#1a1d27] bg-black/40 group-hover:border-[#2563eb]/50 transition-colors duration-300">
                    <Icon className="w-4.5 h-4.5 text-[#2563eb]" />
                  </span>
                  <span className="font-mono text-sm text-[#8b95a5] group-hover:text-white transition-colors duration-300">
                    {e.year}
                  </span>
                </div>

                <div>
                  <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#2563eb]">
                    {t.education.cats[e.cat]}
                  </span>
                  <h3 className="font-display font-semibold text-lg text-white leading-snug mt-1.5">{e.title}</h3>
                  <div className="flex items-center gap-2 mt-3 text-[#8b95a5]">
                    <span className="text-sm">{e.org}</span>
                    <span className="w-1 h-1 rounded-full bg-[#2563eb]" />
                    <span className="font-mono text-[11px]">{t.education.concluded}</span>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
